import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaStar,
  FaMagic,
  FaRocket,
  FaChartBar,
  FaUsersCog,
  FaInfinity,
  FaShieldAlt
} from 'react-icons/fa';
import './BootcampBenefits.css';

const BootcampBenefits = () => {
  const benefits = [
    {
      icon: <FaMagic />,
      title: 'No Coding Required',
      description: 'Build sophisticated trading bots using plain English prompts with our AI Bot Builder.',
      highlight: 'Perfect for beginners'
    },
    {
      icon: <FaRocket />,
      title: 'BotSpot Workflow',
      description: 'Build, backtest, revise, and prepare bots inside the same platform you will use after the course.',
      highlight: 'Build in the real tool'
    },
    {
      icon: <FaChartBar />,
      title: 'Strategy Examples',
      description: 'Use example bots, templates, and course workflows as starting points while you learn.',
      highlight: 'Concrete starting points'
    },
    {
      icon: <FaUsersCog />,
      title: 'Expert Guidance',
      description: 'Get personalized help from our team and connect with 2,400+ active traders.',
      highlight: 'Community support'
    },
    {
      icon: <FaInfinity />,
      title: 'Unlimited Replays',
      description: 'Rewatch all sessions anytime and learn at your own pace with lifetime access.',
      highlight: 'Learn on your schedule'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Risk Management',
      description: 'Master proper risk controls and backtesting before risking real capital.',
      highlight: 'Trade with confidence'
    }
  ];

  const stats = [
    {
      number: '5',
      label: 'Live Weeks',
      suffix: ''
    },
    {
      number: '2,400',
      label: 'Community Members',
      suffix: '+'
    },
    {
      number: '30',
      label: 'Ready-Made Algorithms',
      suffix: '+'
    },
    {
      number: '100',
      label: 'No-Code',
      suffix: '%'
    }
  ];

  return (
    <div className="bootcamp-benefits">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="bootcamp-benefits-header">
              <h2 className="bootcamp-benefits-title">
                <FaStar className="me-3" />
                Why Choose Our AI Bootcamp?
              </h2>
              <p className="bootcamp-benefits-subtitle">
                Get a practical path for turning strategy ideas into BotSpot workflows you can test and improve
              </p>
            </div>
          </Col>
        </Row>

        {/* Stats Section */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <div className="bootcamp-stats">
              {stats.map((stat, index) => (
                <div key={index} className="bootcamp-stat-item">
                  <div className="bootcamp-stat-number">
                    {stat.number}<span className="bootcamp-stat-suffix">{stat.suffix}</span>
                  </div>
                  <div className="bootcamp-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        {/* NEW Benefits Grid */}
        <Row className="justify-content-center">
          <Col lg={11}>
            <div className="new-benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="new-benefit-card">
                  <div className="new-benefit-badge">
                    {benefit.highlight}
                  </div>

                  <div className="new-benefit-icon">
                    {benefit.icon}
                  </div>

                  <h4 className="new-benefit-title">
                    {benefit.title}
                  </h4>

                  <p className="new-benefit-description">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        {/* Call to Action */}
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="bootcamp-benefits-cta">
              <div className="bootcamp-benefits-cta-content">
                <h3 className="bootcamp-benefits-cta-title">
                  Ready to Build Your AI Investing Workflow?
                </h3>
                <p className="bootcamp-benefits-cta-description">
                  Join the next cohort, build alongside Rob, and leave with a repeatable workflow for turning ideas into bots.
                </p>
                <div className="bootcamp-benefits-guarantee">
                  <FaShieldAlt className="me-2" />
                  30-day money-back guarantee • Payment plans available
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BootcampBenefits;
